// Snapshot the URL query string ONCE, at initial page load, before React Router
// mounts and rewrites the URL (the `/` -> `/chat` -> `/login` redirect chain
// otherwise strips the query before the Login component's effect can read it).
//
// This module's top-level code runs the moment it is first imported. index.js
// imports it before anything else so the snapshot is taken while the original
// participant link (e.g. ?u=p1&pw=Pretend1234&pid=...) is still intact.

let snapshot = '';
try {
  snapshot = window.location.search || '';
} catch (e) {
  snapshot = '';
}

// Also persist for the current tab so a full reload mid-flow still has it.
try {
  if (snapshot) {
    sessionStorage.setItem('login_prefill_search', snapshot);
  }
} catch (e) {
  // sessionStorage may be unavailable (private mode); ignore.
}

export function getInitialSearch() {
  if (snapshot) return snapshot;
  try {
    return sessionStorage.getItem('login_prefill_search') || '';
  } catch (e) {
    return '';
  }
}

export function clearInitialSearch() {
  snapshot = '';
  try {
    sessionStorage.removeItem('login_prefill_search');
  } catch (e) {
    // ignore
  }
}
